<template>
  <div class="container" v-if="show">
    <div class="logo"></div>
    <div class="tit"></div>
    <div class="tit_txt">2025年各站点分布</div>
    <div class="site" v-for="(item,idx) in site_list" v-if="site_list.length>0" :class="{active:(item.status==2),prev:(item.status==1)}" @click="goSite(item.status,item.id,item.is_close)" v-html="item.txt"></div>
  </div>
</template>

<script>
let that,token;
import {Toast, Form, Field, Button, Popup, Picker} from 'vant';
export default {
  name: "Home",
  components:{
    'van-form':Form,
    'van-field':Field,
    'van-button':Button,
    'van-popup':Popup,
    'van-picker':Picker,
  },
  data(){
    return{
      show:false,
      site_list:[],
    }
  },
  created() {
    that=this;
    /*if(this.$route.query.is_test){
      this.isOpen=true;
    }*/
    token=localStorage.getItem('token');
    if(token){
      this.getData();
      this.show=true;
    }else{
      this.$Global.goLogin();
    }
  },
  methods:{
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    onSubmit(values) {
      console.log('submit', values);
      this.sub();
    },
    onConfirm(value,index) {
      this.team = value;
      this.form_arr.team = index+1;
      this.showPicker = false;
    },
    sub(){
      if(!this.sub_status){
        return false;
      }
      this.sub_status=false;
      this.$http(this.$Global.api_base+'login.php',this.form_arr,'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        that.sub_status=true;
        if(res.status==1){
          if(res.token){
            localStorage.setItem('token',res.token);
            that.token=res.token;
            that.show=false;
            that.isLogin=true;
            that.$router.push('/story_cat.html');
          }else{
            Toast('登录失败，请重试');
          }
        }else{
          Toast(res.info);
        }
      }).catch(function (error) {
        console.log(error);
        /*Toast(error);*/
      });
    },
    getData() {
      this.$http(that.$Global.api_base+'checkLogin.php',{},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.status==1){
          that.site_list=res.site_list;
          // that.$router.push('/story_cat.html');
        }
        // console.log(that.site_list);
      }).catch(function (error) {
        console.log(error);
      })
    },
    goSite(status,id,is_close){
      if(status&&status>0){
        if(is_close){
          Toast('通道已关闭');
          return false;
        }
        this.$router.push('/site/'+id+'.html');
      }
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  position: relative;
  padding-bottom: 4rem;
  flex-shrink: 0;
  overflow: hidden;
}
.logo{
  width: 5.71rem;
  height: .58rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 5vh;
  background: var(--home_logo) no-repeat;
  background-size: 100% auto;
}
.tit{
  width: 6.68rem;
  height: .96rem;
  position: relative;
  background: var(--home_tit) no-repeat;
  background-size: 100% auto;
  flex-shrink: 0;
  margin: 10vh auto 0;
}
.tit_txt{
  color: #ffffff;
  font-size: .54rem;
  font-weight: bold;
  text-align: center;
  margin-top: 3vh;
  margin-bottom: .5rem;
}
.site{
  border: .01rem solid #ffffff;
  border-radius: .5rem;
  background-color: #bbbbbb;
  width: 6.16rem;
  min-height: .9rem;
  /*line-height: .62rem;*/
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .38rem;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  margin: 0 auto .34rem;
  padding: .1rem;
  box-sizing: border-box;
}
.site.active{
  background-color: #ffb838;
}
.site.prev{
  background-color: #ff5825;
}
  .btn_sub{
    width: 3rem;
    font-size: .32rem;
    color: #952112;
    margin: 40vh auto 0;
  }
@media screen and (max-height: 400px) {
  .container{
    background-size: 100% auto;
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/Index.vue